module.exports = __webpack_public_path__ + "static/media/african-american-1436660_1280.97c35483.jpg";